// 图片映射前缀
  // const imageBaseURL = 'https://tymobeauty.com/cdn/shop/files/';

  // 图片映射表
const imageMap = {
    'source1': [
        '/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_06',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_06_blacktag.webp?v=1772608462',
        'en'
    ],
    'source2': [
        '/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_02',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_02_blacktag.webp?v=1772608462',
        'en'
    ],
    'source3': [
        '/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_05',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_05_blacktag.webp?v=1772608462',
        'en'
    ],
    'source4': [
        '/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_09',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_Hair_Dryer_Brush_product_main_image_09_blacktag.webp?v=1772608462',
        'en'
    ],
    'source5': [
        '/files/HC303P_AIRBEAM_PINK_Hair_Dryer_Brush_product_main_image_06',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_Hair_Dryer_Brush_product_main_image_06_blacktag.webp?v=1772608480',
        'en'
    ],
    'source6': [
        '/files/HC303P_AIRBEAM_PINK_Hair_Dryer_Brush_product_main_image_02',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_Hair_Dryer_Brush_product_main_image_02_blacktag.webp?v=1772608480',
        'en'
    ],
    'source7': [
        '/files/HC303P_AIRBEAM_PINK_Hair_Dryer_Brush_product_main_image_05',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_Hair_Dryer_Brush_product_main_image_05_blacktag.webp?v=1772608480',
        'en'
    ],
    'source8': [
        '/files/HC303P_AIRBEAM_PINK_Hair_Dryer_Brush_product_main_image_09',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_Hair_Dryer_Brush_product_main_image_09_blacktag.webp?v=1772608480',
        'en'
    ],
    'source9': [
        '/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-PC',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-PC_blacktag.webp?v=1772608486',
        'all'
    ],
    'source10': [
        '/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-MB',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-mb_blacktag.webp?v=1772608486',
        'all'
    ],
    'source11': [
        '/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-1',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-2.webp?v=1767151879',
        'all'
    ],
    'source11-1': [
        '/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-2',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-3_blacktag.webp?v=1772608486',
        'all'
    ],
    'source12': [
        '/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-3',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303P_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-2_blacktag.webp?v=1772608486',
        'all'
    ],
    'source13': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-3',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-3_blacktag.webp?v=1772608508',
        'all'
    ],
    'source14': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-3_mb',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-3_mb_blacktag.webp?v=1772608508',
        'all'
    ],
    'source15': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-1',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-2.webp?v=1766987679',
        'all'
    ],
    'source16': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-1_mb',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-2_mb.webp?v=1767089849',
        'all'
    ],
    'source15-1': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-2',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-1_blacktag.webp?v=1772608508',
        'all'
    ],
    'source16-1': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-2_mb',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_2-1_mb_blacktag.webp?v=1772608508',
        'all'
    ],
    'source17': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-PC',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-PC_blacktag.webp?v=1772608468',
        'all'
    ],
    'source18': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1-MB',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_1_mb_blacktag.webp?v=1772608468',
        'all'
    ],
    'source19': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-2',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-2_blacktag.webp?v=1772608468',
        'all'
    ],
    'source20': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-3',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-1.webp?v=1766987679',
        'all'
    ],
    'source20-1': [
        '/files/HC303_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-1',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303B_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-3_blacktag.webp?v=1772608468',
        'all'
    ],
    'source21': [
        '/files/HC303G_AIRBEAM_CHAMPAGNE_Hair_Dryer_Brush_product_main_image_02',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303G_AIRBEAM_Hair_Dryer_Brush_product_main_image_06_blacktag.webp?v=1772608494',
        'en'
        ],
    'source22': [
        '/files/HC303G_AIRBEAM_CHAMPAGNE_Hair_Dryer_Brush_product_main_image_04',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303G_AIRBEAM_Hair_Dryer_Brush_product_main_image_02_blacktag.webp?v=1772608493',
        'en'
        ],
    'source23': [
        '/files/HC303G_AIRBEAM_CHAMPAGNE_Hair_Dryer_Brush_product_main_image_05',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303G_AIRBEAM_Hair_Dryer_Brush_product_main_image_05_blacktag.webp?v=1772608494',
        'en'
        ],
    'source24': [
        '/files/HC303G_AIRBEAM_CHAMPAGNE_Hair_Dryer_Brush_product_main_image_09',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303G_AIRBEAM_Hair_Dryer_Brush_product_main_image_09_blacktag.webp?v=1772608493',
        'en'
        ],
    'source25': [
        '/files/HC303G_AIRBEAM_CHAMPAGNE_powerful_Hair_Dryer_Brush_product_details_image_all_3-1',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303G_AIRBEAM_CHAMPAGNE_powerful_Hair_Dryer_Brush_product_details_image_all_3-2.webp?v=1769739088',
        'all'
        ],
    'source25-1': [
        '/files/HC303G_AIRBEAM_CHAMPAGNE_powerful_Hair_Dryer_Brush_product_details_image_all_3-2',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC303G_AIRBEAM_powerful_Hair_Dryer_Brush_product_details_image_all_3-3_blacktag.webp?v=1772608501',
        'all'
        ],
    'source26': [
        'Home_page_TYMO_ROVY_volumious_hair_waver_Memorial_Day_Sale_Slide_Banner_4',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_ROVY_volumious_hair_waver_Memorial_Day_Sale_Slide_Banner_4_Black.webp?v=1778488047',
        'all'
        ],
    'source27': [
        'Home_page_TYMO_CURLPRO_PLUS_auto_curler_Memorial_Day_Sale_Slide_Banner_1',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_CURLPRO_PLUS_auto_curler_Memorial_Day_Sale_Slide_Banner_1_Black.webp?v=1778488048',
        'all'
        ],
    'source28': [
        'Home_page_TYMO_STYLUX_thermal_round_brush_Memorial_Day_Sale_Slide_Banner_3',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_STYLUX_thermal_round_brush_Memorial_Day_Sale_Slide_Banner_3_Black.webp?v=1778488047',
        'all'
        ],
    'source29': [
        'Home_page_TYMO_AIRFLOW_cold_air_flat_iron_and_curler_styler_Memorial_Day_Sale_Slide_Banner_6',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_AIRFLOW_cold_air_flat_iron_and_curler_styler_Memorial_Day_Sale_Slide_Banner_6_Black.webp?v=1778488044',
        'all'
        ],
    'source30': [
        'Home_page_TYMO_AIRBEAM_Hair_Dryer_Brush_Memorial_Day_Sale_Slide_Banner_7',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_AIRBEAM_Hair_Dryer_Brush_Memorial_Day_Sale_Slide_Banner_7_Black.webp?v=1778488042',
        'all'
        ],
    'source31': [
        'Home_page_TYMO_RING_PLUS_hair_straightener_brush_Memorial_Day_Sale_Slide_Banner_2',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_RING_PLUS_hair_straightener_brush_Memorial_Day_Sale_Slide_Banner_2_Black.webp?v=1778488048',
        'all'
        ],
    'source32': [
        'Home_page_HC106_TYMO_FLIPRO_hair_straightening_comb_Memorial_Day_Sale_Slide_Banner_8',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_HC106_TYMO_FLIPRO_hair_straightening_comb_Memorial_Day_Sale_Slide_Banner_8_Black.webp?v=1778488041',
        'all'
        ],
    'source33': [
        'Home_page_TYMO_CURLPRO_auto_curler_Memorial_Day_Sale_Slide_Banner_5',
        'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/Home_page_TYMO_CURLPRO_auto_curler_Memorial_Day_Sale_Slide_Banner_5_Black.webp?v=1778488048',
        'all'
        ]
};



    const jordanImageMap = {
      'source1': [
          '/files/HC506_TYMO_AIRFLOW_separation_2_in_1_straightener_and_curler_why_choose_tymo_airflow_product_details_image_all_01_black',
          'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC506_TYMO_AIRFLOW_separation_2_in_1_straightener_and_curler_why_choose_tymo_airflow_product_details_image_all_01.webp?v=1775202403',
        'all'
      ],
      'source2': [
          '/files/HC506_TYMO_AIRFLOW_2_in_1_straightener_and_curler_cold_air_styling_tech_long_lasting_results_product_main_image_all_02_black',
          'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/HC506_TYMO_AIRFLOW_2_in_1_straightener_and_curler_cold_air_styling_tech_long_lasting_results_product_main_image_all_02.webp?v=1775208532',
        'en'
      ],
      'source3': [
          '/files/DE_HC506_TYMO_AIRFLOW_2-IN-1_Kaltluftstyler_Lockenstab_und_Glatteisen_Produktbilder_2_black',
          'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/DE_HC506_TYMO_AIRFLOW_2-IN-1_Kaltluftstyler_Lockenstab_und_Glatteisen_Produktbilder_1_converted.webp?v=1775208841',
        'de'
      ],
      'source4': [
          '/files/FR_HC506_TYMO_AIRFLOW_thermal_brush_product_main_image_all_2_black',
          'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/FR_HC506_TYMO_AIRFLOW_thermal_brush_product_main_image_all_2_8_11zon.webp?v=1775208672',
        'fr'
      ],
      'source5': [
          '/files/ES_HC506_TYMO_AIRFLOW_2_in_1_straightener_and_curler_cold_air_styling_tech_long_lasting_results_product_main_image_all_02_black',
          'https://cdn.shopify.com/s/files/1/0094/4839/0711/files/ES_HC506_TYMO_AIRFLOW_2_in_1_straightener_and_curler_cold_air_styling_tech_long_lasting_results_product_main_image_all_02.webp?v=1775208724',
        'es'
      ]
  };
  

  // 设置Cookie函数，过期时间为1年
  function setCookie(name, value) {
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString(); // 1年过期
    document.cookie = `${name}=${value}; expires=${expires}; path=/`; // 设置Cookie
  }

  // 获取Cookie函数
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // 检查URL中的UTM参数，并设置Cookie
const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('utm_content') && urlParams.get('utm_content').includes('blacktag')) {
    setCookie('Dynamic_img', 'black'); // 设置过期时间为1年的Cookie
  }
  else if (urlParams.get('utm_content') && urlParams.get('utm_content').includes('jordanpthomson')) {
    setCookie('Dynamic_img', 'jordan'); // 设置过期时间为1年的Cookie
  }

    const dynamicImgValue = getCookie('Dynamic_img');

if (dynamicImgValue === 'black') {
    
    const pageLang = (document.documentElement.lang || 'en').split('-')[0];
    const imageElements = document.querySelectorAll('img'); // 选择所有img元素

    imageElements.forEach(imageElement => {
        const hasPcBlack = imageElement.hasAttribute('pc-black');
        const hasMbBlack = imageElement.hasAttribute('mb-black');

     if (hasPcBlack || hasMbBlack) {
            const picture = imageElement.closest('picture');
            if (!picture) return;

            // desktop/移动不再用于“读写”，直接按 media 对应区间写 srcset
            if (hasPcBlack) {
                const pcBlack = imageElement.getAttribute('pc-black');
                if (pcBlack && pcBlack !== 'null') {
                const maxSource = picture.querySelector('source[media="(max-width: 767px)"]');
                if (maxSource) maxSource.setAttribute('srcset', pcBlack);
                }
            }

            if (hasMbBlack) {
                const mbBlack = imageElement.getAttribute('mb-black');
                if (mbBlack && mbBlack !== 'null') {
                // 注意：你要求这里是 (min-width: 767px)
                const minSource = picture.querySelector('source[media="(min-width: 767px)"]');
                if (minSource) minSource.setAttribute('srcset', mbBlack);
                }
            }
    }
    else {
        const currentSrc = imageElement.src;

        // 检查src是否包含数组第一个值
        for (const key in imageMap) {
            // if (imageMap[key][0] && currentSrc.includes(imageMap[key][0])) {
            // // 替换为带前缀的第二个值
            // imageElement.src = imageMap[key][1];
            // imageElement.srcset=imageMap[key][1];
            // break; // 找到后退出循环
            // }
            const [matchStr, replaceUrl, lang] = imageMap[key];
            if (
                matchStr &&
                currentSrc.includes(matchStr) &&
                (
                    lang === 'all' ||   
                    lang === pageLang  
                )
            ) {
                imageElement.src = replaceUrl;
                imageElement.srcset = replaceUrl;
                break;
            }
        }
    }

  })
  
    document.querySelectorAll('video').forEach(videoEl => {
      const blackTagHtml = videoEl.getAttribute('blacktagurl');

      if (blackTagHtml && blackTagHtml !== 'null') {
        // blacktagurl 是一段 HTML 字符串：解析后把整段 video 替换掉
        const doc = new DOMParser().parseFromString(blackTagHtml, 'text/html');

        // 优先取解析结果中的第一个 video，否则取第一个元素节点
        const newVideo = doc.querySelector('video') || doc.body.firstElementChild;

        if (newVideo) {
          videoEl.replaceWith(newVideo);
        }
      }
    });

} else if (dynamicImgValue === 'jordan') {
    // activeImageMap = jordanImageMap;
    const pageLang = (document.documentElement.lang || 'en').split('-')[0];

    document.querySelectorAll('img').forEach(imageElement => {
        const currentSrc = imageElement.src;

        for (const key in jordanImageMap) {

            const [matchStr, replaceUrl, lang] = jordanImageMap[key];

            if (
                matchStr &&
                currentSrc.includes(matchStr) &&
                (
                    lang === 'all' ||   
                    lang === pageLang  
                )
            ) {
                imageElement.src = replaceUrl;
                imageElement.srcset = replaceUrl;
                break;
            }
        }

    });
}




document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      if (video.dataset.loaded) return;
      video.querySelectorAll('source').forEach(source => {
        if (dynamicImgValue === 'black' && source.dataset.srcBlack) {
          source.src = source.dataset.srcBlack;
        } else if (source.dataset.src) {
          source.src = source.dataset.src;
        }
      });

      video.load();
      video.dataset.loaded = 'true';
      if (video.autoplay) {
        video.play().catch(() => {});
      }

      observer.unobserve(video);

    });
  }, {
    rootMargin: '300px'
  });

  document.querySelectorAll('.lazy-video').forEach(video => {
    observer.observe(video);
  });
});
